import { useState } from "react";
import { Button } from "@mui/material";

import HistoryView from "components/history/HistoryView";
import { ProjectConfigSchema } from "hooks/pavm/base";

const HistoryDialog = ({
  type,
  config,
  label = "View",
  disabled = false,
}: {
  type: string;
  label?: string;
  disabled?: boolean;
  config: ProjectConfigSchema;
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button
        size="small"
        color="secondary"
        variant="contained"
        disabled={disabled}
        onClick={handleOpen}
      >
        {label}
      </Button>

      <HistoryView
        open={open}
        type={type}
        config={config}
        onClose={handleClose}
      />
    </div>
  );
};

export default HistoryDialog;
